import Chart, { useChart } from "src/components/chart";
import { alpha, useTheme } from "@mui/material/styles";
import { fPercent } from "src/utils/format-number";

interface Props {
    options?: ApexCharts.ApexOptions;
    series?: {
        name: string;
        data: number[];
        color?: string;
    }[];
}

const HEIGHT = 55;

export default function ColumnStackVertical({ options = {}, series = [] }: Props) {
    const colors = ["#18A155", "#BC9510", '#F5CE47'];
    const theme = useTheme();

    const annotations: PointAnnotations[] = [];
    
    series.forEach((item, index) => {
        const offsetX = series.slice(0, index).reduce((acc, curr) => acc + curr.data[0], 0);
        const prevOffsetX = index !== 0 ? annotations[index - 1].x as number : 0;
        const opt = {
            x: offsetX,
            y: 0,
            marker: {
                size: 0,
                strokeWidth: 0,
                fillColor: alpha(item.color || '', 0),
                strokeColor: alpha(item.color || '', 0),
            },
            label: {
                offsetY: 5,
                borderColor: alpha(theme.palette.background.paper, 0),
                text: fPercent(item.data[0]),
                style: {
                    fontSize: '13px',
                    fontWeight: 600,
                    background: alpha(theme.palette.background.paper, 0),
                    color: item.color
                }
            }
        }

        if (index === 0) {
            opt.x = 0;
            return annotations.push(opt)
        }

        if (prevOffsetX + 40 > opt.x) {
            opt.x = prevOffsetX + 20;
        }

        annotations.push(opt)
    })

    const chartOptions = useChart({
        chart: {
            type: "bar",
            stacked: true,
            stackType: '100%',
            offsetX: -10,
            offsetY: 10,
            width: '100%',
            height: "50px"
        },
        plotOptions: {
            bar: {
                barHeight: '6px',
                borderRadius: 1.5,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                horizontal: true,
            },
        },
        xaxis: {
            labels: {
                show: false,
            },
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
        },
        grid: {
            show: false,
            xaxis: {
                lines: {
                    show: false
                }
            },
            yaxis: {
                lines: {
                    show: false
                }
            },
        },
        tooltip: {
            enabled: false,
        },
        dataLabels: {
            enabled: false,
        },
        legend: {
            show: false,
        },
        annotations: {
            points: annotations
        },
        yaxis: {
            show: false,
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            }
        },
        colors: colors,
        ...options
    });

    return <Chart height={HEIGHT} type="bar" series={series} options={chartOptions} />
}